import { render, staticRenderFns } from "./ManaBanner.vue?vue&type=template&id=4208777d&"
import script from "./ManaBanner.vue?vue&type=script&lang=js&"
export * from "./ManaBanner.vue?vue&type=script&lang=js&"
import style0 from "./ManaBanner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports